import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'
import { ContactStatusIcon } from 'legacy/lut/components/widgets/public/contactData/ContactStatusIcon'
import { appGetState } from 'legacy/lut/store'
import { lookupGetStateOld } from 'legacy/lut/store'
import React from 'react'

import { stylesTable } from 'core-components/library/list'
import { IColumn } from 'core-components/library/list/types'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './Cell.module.scss'

export interface IPartnerDataCellProps {
  item: DataModel
  column: IColumn
  cellAttrs: IObjectAny
}

type TPhone = 'MobilePhone' | 'WorkPhone'

const getPhoneCell = (dataModel: DataModel, cellAttributes: IObjectAny, phoneType: TPhone) => {
  if ((dataModel.get(phoneType) || '').length) {
    const phoneValue = `${dataModel.get(`${phoneType}_Prefix`) || ''}${
      dataModel.get(phoneType) || ''
    }`
    return (
      <td {...cellAttributes} className={stylesTable.cell}>
        <PhoneCall
          value={phoneValue}
          guid={dataModel.get('HPD_Contact_GUID')}
          partnerId={dataModel.get('PartnerID')}
          onClick={(e: any) => {
            e.stopPropagation()
          }}
        />
      </td>
    )
  }

  return undefined
}

export function ContactDataCell({ item, column, cellAttrs }: IPartnerDataCellProps) {
  const countries = lookupGetStateOld().references.countries
  switch (column.field) {
    case 'MobilePhone':
    case 'WorkPhone':
      const phoneCell = getPhoneCell(item, cellAttrs, column.field)
      if (phoneCell) {
        return phoneCell
      }
      break
    case 'ContactID':
      return (
        <td {...cellAttrs} className={stylesTable.cell}>
          <ContactStatusIcon item={item} />
          {item.get('ContactID')}
        </td>
      )
    case 'CountryOfBusiness':
      if (countries) {
        const countryCode = item.get('CountryOfBusiness')
        const cData = countries.find((el) => el.value === countryCode)
        return (
          <td {...cellAttrs} className={stylesTable.cell}>
            {cData ? cData.name : countryCode}
          </td>
        )
      }
      break
  }

  return (
    <td {...cellAttrs} className={stylesTable.cell}>
      {item.get(column.field)}
    </td>
  )
}
